import React, { useState } from 'react';
import axios from 'axios';
import { Box, Button, Grid, Modal, TextField, Typography, Divider, IconButton } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

const CrearInventarioModal = () => {
    const [abierto, setAbierto] = useState(false);
    const [nombreInventario, setNombreInventario] = useState('');
    const [codigoInventario, setCodigoInventario] = useState('');

    // Obtener el empresa_idEmpresa desde localStorage
    const usuario = JSON.parse(localStorage.getItem('usuario'));
    const empresa_idEmpresa = usuario?.empresa_idEmpresa;

    const abrirModal = () => setAbierto(true);
    const cerrarModal = () => setAbierto(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const datosInventario = {
            Inventario: nombreInventario,
            CodigoInventario: codigoInventario,
            empresa_idEmpresa: empresa_idEmpresa,
        };

        try {
            const respuesta = await axios.post('https://invio.datachile.site/Web/Inventarios/CrearInventario.php', datosInventario, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            console.log('Respuesta de la API:', respuesta.data);
            console.log(datosInventario);
            cerrarModal();
        } catch (error) {
            console.error('Error al enviar los datos a la API:', error);
        }
    };

    return (
        <div>
            <div style={{ marginBottom: '16px' }}>
                <IconButton
                    onClick={abrirModal}
                    color="primary"
                    style={{
                        padding: '6px 12px',
                        backgroundColor: '#1976d2',
                        color: 'white',
                        borderRadius: '4px',
                        fontSize: '14px',
                    }}
                >
                    <span>Crear Inventario</span>
                </IconButton>
            </div>


            <Modal
                open={abierto}
                onClose={cerrarModal}
                aria-labelledby="modal-titulo"
                aria-describedby="modal-descripcion"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                    }}
                >
                    <Typography id="modal-titulo" variant="h6" component="h2" gutterBottom>
                        Crear Inventario
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Nombre del Inventario"
                                    variant="outlined"
                                    size="small"
                                    margin="dense"
                                    value={nombreInventario}
                                    onChange={(e) => setNombreInventario(e.target.value)}
                                    sx={{ mb: 2 }}
                                />
                                <TextField
                                    fullWidth
                                    label="Código del Inventario"
                                    variant="outlined"
                                    size="small"
                                    margin="dense"
                                    value={codigoInventario}
                                    onChange={(e) => setCodigoInventario(e.target.value)}
                                    sx={{ mb: 2 }}
                                />
                            </Grid>
                        </Grid>
                        <Divider sx={{ my: 2 }} />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                sx={{ mt: 2 }}
                            >
                                Guardar
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Modal>
        </div>
    );
};

export default CrearInventarioModal;
